import axios from 'axios';
import { getAccessToken, RefreshLoginStatus } from '@/utils/login';
import { generateUuid } from '@/utils';

import { addPendingRequest, removePendingRequest } from './cancel';
import { TIME_OUT } from './const';

const id = generateUuid();
const expiredCode = '401';

const ua = navigator.userAgent.toUpperCase();
const platform = /(IPHONE|IPAD|IPOD|IOS)/i.test(ua) ? 'iOS' : (/(ANDROID)/i.test(ua) ? 'Android' : 'web');
const instance = axios.create({
  timeout: TIME_OUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  async (config) => {
    config.headers = {
      'X-VERSION': '1.0.0',
      'X-PLATFORM': platform,
      'X-UDID': id,
      'X-LANG': 'en',
      ...config.headers,
    };
    const token = getAccessToken();
    // if (!token && config.url !== '/authorizations/guest') {
    //   // await login();
    //   token = getAccessToken();
    // }
    config.headers.Authorization = `Bearer ${token}`;
    removePendingRequest(config); // 取消重复请求
    addPendingRequest(config); // 添加当前请求
    return config;
  },
  (error) => Promise.resolve({
    errorType: 'request',
    status: error.status,
    message: error.message,
    code: -1,
    data: {},
  }),
);

instance.interceptors.response.use(
  async (response) => {
    removePendingRequest(response.config);
    const code = String(response.data?.code || '');
    if (code === expiredCode) {
      await RefreshLoginStatus();
      window.location.reload();
    }
    return response.data;
  },
  async (error) => {
    console.log('request error------', error);
    removePendingRequest(error.config || {});
    const code = String(error?.status || '');
    if (code === expiredCode) {
      await RefreshLoginStatus();
      window.location.reload();
    }
    return Promise.resolve({
      errorType: 'response',
      status: error.status,
      message: error.message,
      code: -1,
      data: {},
    });
  },
);

export default instance;
